import React from 'react';
import {Route} from 'react-router-dom';
import AsyncDetail from '../../../business/news/detail/async';
import DefaultConsumerLayout from '../../../../components/layout/DefaultConsumerLayout';

export default [
  <Route
      key="/:type(consumer)/news/detail/:id?"
      element={
        <DefaultConsumerLayout
          breadcrumb={[
            {
              position: 1,
              name: 'Home',
              item: '/',
            },
            {
              position: 2,
              name: 'Consumer',
              item: '/consumer',
            },
            {
              position: 3,
              name: 'news_title',
              item: '/consumer/news/detail',
            },
          ]}
        />
      }
    >
      <Route path="consumer/news/detail/:id?" element={<AsyncDetail />} />
    </Route>,
    <Route
      key="/:type(consumer)/news/:newsHandle?"
      element={
        <DefaultConsumerLayout
          breadcrumb={[
            {
              position: 1,
              name: 'Home',
              item: '/',
            },
            {
              position: 2,
              name: 'Consumer',
              item: '/consumer',
            },
            {
              position: 3,
              name: 'news_title',
              item: '/consumer/news',
            },
          ]}
        />
      }
    >
      <Route path="consumer/news/:newsHandle?" element={<AsyncDetail />} />
    </Route>,
    <Route
      key="/:type(consumer)/news/preview/:id?"
      element={
        <DefaultConsumerLayout
          breadcrumb={[
            {
              position: 1,
              name: 'Home',
              item: '/',
            },
            {
              position: 2,
              name: 'Consumer',
              item: '/consumer',
            },
            {
              position: 3,
              name: 'news_title',
              item: '/consumer/news/preview',
            },
          ]}
        />
      }
    >
      <Route path="consumer/news/preview/:id?" element={<AsyncDetail />} />
    </Route>,
];
